<template>
    <header :class="{ 'header--hide': headerHide, 'header--shadow': headerShadow }">
        <div class="header-wrap">

            <div class="header">
                <button class="toggle" @click="toggleMenu" :class="{ 'toggle--active': menuOpened }">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <h1 class="header-logo" :class="{ 'header-logo--show': headerLogoShow }">
                    <router-link to="/" class="header-logo__link" aria-label="HOME">
                        <img src="@/assets/logo-second.svg" alt="RODEO BROS" v-if="$store.state.hostName === 'R2' || $store.state.hostName === 'Y2'" />
                        <img src="@/assets/logo.svg" alt="RODEO BROS" v-else />
                    </router-link>
                </h1>

                <button class="glass" @click="toggleSearch" :class="{ 'glass--active': !searchState }">
                    <span></span>
                    <span></span>
                    <img src="@/assets/search.svg" alt="" v-show="!searchState">
                </button>
            </div>

            <transition name="menu-fade">
                <div class="search" v-show="searchState">
                    <div class="">
                        <form accept-charset="euc-jp" method="get" action="https://esearch.rakuten.co.jp/rms/sd/esearch/vc" target="_top" class="search-form" v-if="host === 'R1'">
                            <input type="text" name="sitem" placeholder="Search ..." class="search-window" ref="search">
                            <input type="hidden" name="sv" value="6">
                            <input type="hidden" name="sid" value="235529">
                            <input type="hidden" name="su" value="auc-rodeo">
                            <input type="hidden" name="sn" value="ロデオブロスRODEO BROS">
                            <input type="hidden" name="f" value="A">
                            <input type="submit" name="検索" onclick="org=document.charset; document.charset='EUC-JP'; document.sitem.submit(); document.sv.submit(); document.sid.submit(); document.su.submit(); document.sn.submit(); document.f.submit(); document.charset=org;" value="" class="search-icon">
                        </form>

                        <form accept-charset="euc-jp" method="get" action="https://esearch.rakuten.co.jp/rms/sd/esearch/vc" target="_top" class="search-form" v-else-if="host === 'R2'">
                            <input type="text" name="sitem" placeholder="Search ..." class="search-window" ref="search">
                            <input type="hidden" name="sv" value="6">
                            <input type="hidden" name="sid" value="330657">
                            <input type="hidden" name="su" value="rodeo-2nd">
                            <input type="hidden" name="sn" value="RODEO BROS 2nd">
                            <input type="hidden" name="f" value="A">
                            <input type="submit" name="検索" onclick="org=document.charset; document.charset='EUC-JP'; document.sitem.submit(); document.sv.submit(); document.sid.submit(); document.su.submit(); document.sn.submit(); document.f.submit(); document.charset=org;" value="" class="search-icon">
                        </form>

                        <form target="_top" method="get" action="https://store.shopping.yahoo.co.jp/rodeobros/search.html" class="search-form" v-else-if="host === 'Y1'">
                            <input type="text" name="p" placeholder="Search ..." class="search-window" ref="search">
                            <input type="submit" name="検索" value="" class="search-icon">
                        </form>

                        <form target="_top" method="get" action="https://store.shopping.yahoo.co.jp/bros/search.html" class="search-form" v-else-if="host === 'Y2'">
                            <input type="text" name="p" placeholder="Search ..." class="search-window" ref="search">
                            <input type="submit" name="検索" value="" class="search-icon">
                        </form>

                        <form method="get" action="https://www.aun-wa.com/SHOP/list.cgi" target="_top" class="search-form" v-else-if="host === 'O'">
                            <input type="text" name="Search" placeholder="Search ..." class="search-window" ref="search">
                            <input type="submit" value="" class="search-icon">
                        </form>
                    </div>
                </div>
            </transition>

            <transition name="menu-fade">
                <div class="menu" v-show="menuOpened">
                    <transition-group tag="ul" class="menu-list" name="menu-slide" @before-enter="beforeEnter">
                        <li v-for="(menuItem, index) in menu" :key="menuItem.name" :data-index="index" @click="closeMenu" v-show="menuOpened && !((menuItem.name === 'REVIEW' && $store.state.hostName === 'Q') || (menuItem.name === 'MAIL MAGAZINE' && $store.state.hostName === 'Q'))">
                            <!-- Router対応（HOME / NEW ARRIVAL / BRANDS / CATEGORY / WEEKLY RANKING / MONTHLY RANKING） -->
                            <router-link v-if="menuItem.to" :to="menuItem.to">{{ menuItem.name }}</router-link>
                            <a v-else-if="menuItem.link" :href="menuItem.link[$store.state.hostName]">{{ menuItem.name }}</a>
                        </li>
                        <li key="sns" :data-index="menu.length" v-show="menuOpened">
                            <div class="sns">
                                <!-- <div class="sns-text">Find Us On:</div> -->
                                <div v-for="s in sns" :key="s.link" class="sns-ele" :class="s.name">
                                    <a :href="s.link">
                                        <img :src="require('@/assets/' + s.path)" alt="">
                                    </a>
                                </div>
                            </div>
                        </li>
                    </transition-group>
                </div>
            </transition>
        </div>
    </header>
</template>

<script>
export default {
  name: 'Header',

  data () {
    const isHome = this.$route && this.$route.path === '/'

    return {
      host: this.$store.state.hostName,
      searchState: false,
      headerHide: false,
      headerShadow: false,
      // HOME: 非表示 / HOME以外: 表示
      headerLogoShow: !isHome,

      menu: [
        {
          name: 'HOME',
          to: '/',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/pc/',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/',
            Y1: 'https://shopping.geocities.jp/rodeobros/',
            Y2: 'https://shopping.geocities.jp/bros/',
            O: 'https://www.aun-wa.com/',
            W: '/user/24431709/plus/',
            Q: 'https://www.qoo10.jp/shop/RODEO-BROS'
          }
        },
        {
          name: 'NEW ARRIVAL',
          to: '/new',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/more/newarrival.html',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/more/newarrival.html',
            Y1: 'https://shopping.geocities.jp/rodeobros/more/newarrival.html',
            Y2: 'https://shopping.geocities.jp/bros/more/newarrival.html',
            O: 'https://www.aun-wa.com/more/newarrival.html',
            W: '/user/24431709/plus/more/newarrival.html',
            Q: 'https://www.qoo10.jp/shop/RODEO-BROS?minishop_bar_onoff=N&keyword_hist=&sell_coupon_cust_no=nEBWLVMMrHp1aCZrWC1CqA%3D%3D&SellerCooponDisplay=Y&sell_cust_no=nEBWLVMMrHp1aCZrWC1CqA%3D%3D&theme_sid=0&page_type=&global_yn=N&frame_id=&qid=0&search_mode=&fbidx=-1&brandno=&group_code=&gdlc_cd=&gdmc_cd=&gdsc_cd=&delivery_group_no=&sortType=SORT_GD_NO&dispType=UIG4&flt_pri_idx=&filterDelivery=NNNNNANNNN&search_global_yn=N&basis=&shipFromNation=&shipto=ALL&SearchNationCode=&is_research_yn=Y&hid_keyword=&video_goods_yn=&coupon_filter_no=&gd_type=&drugs_type=&promotion_yn=&priceMin=&priceMax=&curPage=1&pageSize=60&partial=on&brandno=&paging_value=2#div_section_filter'
          }
        },
        {
          name: 'BRANDS',
          to: '/brands',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/brandlist1/',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/brandlist1/',
            Y1: 'https://shopping.geocities.jp/rodeobros/brandlist1/',
            Y2: 'https://shopping.geocities.jp/bros/brandlist1/',
            O: 'https://www.aun-wa.com/brandlist1/',
            W: '',
            Q: ''
          }
        },
        {
          name: 'CATEGORY',
          to: '/category',
          link: {
            R1: 'https://item.rakuten.co.jp/auc-rodeo/c/',
            R2: 'https://item.rakuten.co.jp/rodeo-2nd/c/',
            Y1: 'https://store.shopping.yahoo.co.jp/rodeobros/item5bbea6.html',
            Y2: '',
            O: 'https://www.aun-wa.com/categorylist/',
            W: '',
            Q: ''
          }
        },
        {
          name: 'WEEKLY RANKING',
          to: '/weekly-ranking',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/more/week.html',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/more/week.html',
            Y1: 'https://shopping.geocities.jp/rodeobros/more/week.html',
            Y2: 'https://shopping.geocities.jp/bros/more/week.html',
            O: 'https://www.aun-wa.com/more/week.html',
            W: '',
            Q: ''
          }
        },
        {
          name: 'MONTHLY RANKING',
          to: '/monthly-ranking',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/more/month.html',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/more/month.html',
            Y1: 'https://shopping.geocities.jp/rodeobros/more/month.html',
            Y2: 'https://shopping.geocities.jp/bros/more/month.html',
            O: 'https://www.aun-wa.com/more/month.html',
            W: '',
            Q: ''
          }
        },
        {
          name: 'REVIEW',
          link: {
            R1: 'https://review.rakuten.co.jp/shop/4/235529_235529/1.1/',
            R2: 'https://review.rakuten.co.jp/shop/4/330657_330657/1.1/',
            Y1: 'https://shopping.yahoo.co.jp/store_rating/rodeobros/store/review/',
            Y2: 'https://shopping.yahoo.co.jp/store_rating/bros/store/review/',
            O: 'https://www.aun-wa.com/SHOP/rating_list.html',
            W: '/bep/m/kevl10?user=24431709',
            Q: ''
          }
        },
        {
          name: 'MAIL MAGAZINE',
          link: {
            R1: 'https://www.rakuten.co.jp/auc-rodeo/news.html',
            R2: 'https://www.rakuten.co.jp/rodeo-2nd/news.html',
            Y1: 'https://snlweb.shopping.yahoo.co.jp/shp_snl/optin/select/rodeobros',
            Y2: 'https://snlweb.shopping.yahoo.co.jp/shp_snl/optin/select/bros',
            O: 'https://www.aun-wa.com/SHOP/mailmag.html',
            W: '/bep/m/dm40?user=24431709',
            Q: ''
          }
        },
        {
          name: 'COMPANY',
          link: {
            R1: '#/company',
            R2: '#/company',
            Y1: '#/company',
            Y2: '#/company',
            O: '#/company',
            W: '/bep/m/kpaax04?l=shp_005&d=/user/24431709/2',
            Q: 'https://www.qoo10.jp/shop-info/RODEO-BROS?global_yn=N'
          }
        }
      ],
      sns: [
        {
          name: 'instagram',
          path: 'instagram.svg',
          link: 'https://www.instagram.com/rodeobros/'
        },
        {
          name: 'twitter',
          path: 'twitter.svg',
          link: 'https://twitter.com/rodeobros'
        },
        {
          name: 'facebook',
          path: 'facebook.svg',
          link: 'https://www.facebook.com/Rodeobros/'
        }
      ]
    }
  },

  computed: {
    menuOpened () {
      return this.$store.state.menuOpened
    },
    /**
     * HOME判定（hash modeでもOK）
     */
    isHome () {
      return this.$route && this.$route.path === '/'
    }
  },

  watch: {
    // ページ遷移時も表示状態を更新
    $route () {
      this.updateHeaderLogoShow()
    }
  },

  methods: {
    /**
     * トグルのステータスの更新
     */
    toggleMenu () {
      this.$store.commit('toggleMenuState')
    },

    /**
     * メニューを閉じる
     */
    closeMenu () {
      this.$store.commit('closeMenu')
    },

    /**
     * メニューの時差トランジション
     */
    beforeEnter (el) {
      el.style.transitionDelay = 80 * Number(el.dataset.index) + 'ms'
    },

    /**
     * 検索窓の表示非表示の切り替え
     */
    toggleSearch () {
      this.searchState = !this.searchState
      setTimeout(() => {
        this.$refs.search.focus()
      }, 300)
    },

    updateHeaderLogoShow () {
      if (this.isHome) {
        // HOMEのみ 60vh で切り替え
        this.headerLogoShow = window.scrollY >= window.innerHeight * 0.6
      } else {
        // HOME以外は常に表示
        this.headerLogoShow = true
      }
    },

    handleScroll () {
      let beforeY = window.scrollY
      window.addEventListener('scroll', () => {
        if (this.menuOpened) return

        if (beforeY < window.scrollY) {
          // 下にスクロールしているのでヘッダーを隠す
          this.headerHide = true
          this.headerShadow = false
        } else {
          // 上にスクロールしているのでヘッダーを出現させる
          this.headerHide = false
          this.headerShadow = true
        }

        if (window.scrollY <= 200) {
          this.headerShadow = false
        }

        // ロゴ表示判定
        this.updateHeaderLogoShow()

        beforeY = window.scrollY
      })
    }
  },

  mounted () {
    this.updateHeaderLogoShow()
    this.handleScroll()
  }
}
</script>

<style lang="scss" scoped>
$header-height: 130px;
$header-height-tab: 90px;
$header-height-sp: 60px;

header {
    position: sticky;
    top: 0;
    z-index: 10;
    transition: .5s;
    height: $header-height;

    @media screen and (max-width: 722px) {
        height: $header-height-sp;
        background-color: #ffffff;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        height: $header-height-tab;
    }

    &.header--hide {
        top: -$header-height;

        @media screen and (max-width: 722px) {
            top: -$header-height-sp;
        }

        @media screen and (min-width: 723px) and (max-width: 963px) {
            top: -$header-height-tab;
        }
    }
}

.header-logo {
    position: absolute;
    top: 50px;
    left: 50%;
    opacity: 0;
    transition: .5s;
    transform: translateX(-50%);

    @media screen and (max-width: 722px) {
        top: ($header-height-sp - 20px) / 2; // ($header-height-sp - img) / 2
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        top: 30px;
    }

    &.header-logo--show {
        opacity: 1;
    }

    img {
        height: 30px;

        @media screen and (max-width: 722px) {
            height: 20px;
        }

        @media screen and (min-width: 723px) and (max-width: 963px) {
            height: 30px;
        }
    }
}

/* ----- ハンバーガーボタン start ----- */
.toggle {
    position: absolute;
    top: 50px;
    left: 50px;
    z-index: 21;
    width: 30px;
    height: 30px;

    @media screen and (max-width: 722px) {
        top: ($header-height-sp - 30px) / 2; // ($header-height-sp - height) / 2
        left: 20px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        top: 30px;
        left: 30px;
    }

    span {
        position: absolute;
        left: 0;
        width: 100%;
        width: 20px;
        height: 2px;
        background-color: #222222;
        border-radius: 1px;
        transform: translateX(5px);

        &:nth-child(1) {
            top: 0;
            top: 8px;
        }

        &:nth-child(2) {
            top: calc(50% - 1px);
        }

        &:nth-child(3) {
            bottom: 0;
            bottom: 8px;
        }
    }

    &.toggle--active {
        position: fixed;

        span {
            background-color: #ffffff;

            &:nth-child(1) {
                transform: translateY(6px) rotate(-45deg);
                transform: translateX(5px) translateY(6px) rotate(-45deg);
            }

            &:nth-child(2) {
                opacity: 0;
            }

            &:nth-child(3) {
                transform: translateY(-6px) rotate(45deg);
                transform: translateX(5px) translateY(-6px) rotate(45deg);
            }
        }
    }
}

.toggle,
.toggle span {
    box-sizing: border-box;
    display: inline-block;
    transition: all .4s;
}

/* ハンバーガーボタン end */

/* ----- 検索 start ----- */
.glass {
    position: absolute;
    top: 50px;
    right: 50px;
    z-index: 20;
    width: 30px;
    height: 30px;
    text-align: center;

    @media screen and (max-width: 722px) {
        top: ($header-height-sp - 30px) / 2; // ($header-height-sp - height) / 2
        right: 20px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        top: 30px;
        right: 30px;
    }

    span {
        position: absolute;
        right: 8px;
        width: 15px;
        height: 1px;
        background-color: #999999;
        border-radius: 1px;
        transition: .4s;

        &:nth-child(1) {
            top: 8px;
            transform: translateY(6px) rotate(-45deg);
        }

        &:nth-child(2) {
            bottom: 10px;
            transform: translateY(-5px) rotate(45deg);
        }
    }

    &.glass--active {
        span {
            opacity: 0;
        }
    }

    img {
        position: relative;
        top: 1px;
        width: 20px;
    }
}

/* 検索 end */

/* ----- 検索 start ----- */
.search {
    position: absolute;
    top: 50px;
    right: 90px;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;
    height: 30px;

    @media screen and (max-width: 722px) {
        top: ($header-height-sp - 30px) / 2; // ($header-height-sp - height) / 2
        right: 60px;
        background-color: #ffffff;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        top: 30px;
        right: 70px;
    }
}

.search-form {
    position: relative;
}

.search-window {
    box-sizing: border-box;
    display: block;
    width: 100%;
    padding: 2px 12px;

    // background-color: #ffffff;
    border-bottom: 1px solid #d3d3d3;
}

.search-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-image: url(../assets/search.svg);
    background-repeat: no-repeat;
    background-position: top 1px right 0;
    background-size: 20px auto;
    opacity: .3;
}

/* 検索 end */

/* ----- メニュー start ----- */
.menu {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100vw;
    height: 100vh;
    background-color: #222222;
}

.menu-list {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    >li {
        position: relative;

        a {
            display: block;
            padding: 12px 0;
            font-size: 28px;
            color: #ffffff;
        }
    }
}

.menu-fade-enter-active {
    transition: opacity .5s;
}

.menu-fade-leave-active {
    transition: opacity .2s;
}

.menu-fade-enter,
.menu-fade-leave-to {
    opacity: 0;
}

.menu-slide-enter-active {
    left: 0;
    transition: .5s;
}

.menu-slide-leave-active {
    left: 0;
    transition: .2s;
}

.menu-slide-enter,
.menu-slide-leave-to {
    left: -15px;
    opacity: 0;
}

/* メニュー end */

/* ----- SNS start ----- */
.sns {
    display: flex;
    width: 200px;
    margin-top: 24px;

    .sns-text {
        position: relative;
        top: 8px;
        margin-right: 7px;
        font-size: 11px;
        color: #ffffff;
    }

    .sns-ele {
        text-align: center;

        &.twitter {
            margin-left: 5px;
        }

        &.facebook {
            position: relative;
            bottom: 1px;
            left: 1px;
        }

        a {
            display: block;
            padding: 4px;
        }

        img {
            width: 16px;
        }
    }
}

/* SNS end */
</style>
